import React from 'react';
import { useTranslation } from 'react-i18next';

import { PasswordTokenHandler } from 'components';
import { TitleWithUIGuidelines } from 'component-library/atoms/TitleWithUIGuidelines';
import CreateNewPasswordForm from './CreateNewPaswordForm';
import * as S from './styles';
import { PasswordRecommandations } from './PasswordRecommandations';

export const CreateNewPassword = () => {
  const { t } = useTranslation();

  const caractersRecommandations = [
    [
      t('auth.createNewPassword.oneUppercaseLetter'),
      t('auth.createNewPassword.oneSpecialCharacter'),
    ],
    [
      t('auth.createNewPassword.oneLowercaseLetter'),
      t('auth.createNewPassword.oneDigit'),
    ],
  ];

  return (
    <PasswordTokenHandler isTokenRequired>
      {(token) => (
        <S.StyledContainer>
          <PasswordRecommandations
            caractersRecommandations={caractersRecommandations}
          />
          <TitleWithUIGuidelines
            title={t('auth.createNewPassword.chooseMyPassword')}
          />
          <CreateNewPasswordForm token={token!} />
        </S.StyledContainer>
      )}
    </PasswordTokenHandler>
  );
};
